@if (organization(); as currentOrganization) {
  <app-details-shell
    [title]="currentOrganization.name"
    [actions]="actions"
  >
    <section class="space-y-3">
      <h3 class="text-base font-semibold text-foreground">
        {{ 'settings.organizations.details.sections.info' | transloco }}
      </h3>
      <dl class="overflow-hidden rounded-xl border border-border bg-background">
        <div
          class="grid gap-2 border-b border-border px-4 py-3 text-sm sm:grid-cols-2"
        >
          <dt class="text-muted-foreground">
            {{ 'settings.organizations.details.organizationId' | transloco }}
          </dt>
          <dd class="font-mono text-foreground sm:text-right">
            #{{ currentOrganization.id }}
          </dd>
        </div>
        <div
          class="grid gap-2 border-b border-border px-4 py-3 text-sm sm:grid-cols-2"
        >
          <dt class="text-muted-foreground">
            {{ 'settings.organizations.details.name' | transloco }}
          </dt>
          <dd class="text-foreground sm:text-right">
            {{ currentOrganization.name }}
          </dd>
        </div>
        @if (currentOrganization.createdAt) {
          <div class="grid gap-2 px-4 py-3 text-sm sm:grid-cols-2">
            <dt class="text-muted-foreground">
              {{ 'settings.organizations.details.createdAt' | transloco }}
            </dt>
            <dd class="text-foreground sm:text-right">
              {{ currentOrganization.createdAt | date: 'medium' }}
            </dd>
          </div>
        }
      </dl>
    </section>

    <workforce-organization-persons [organizationId]="currentOrganization.id" />
  </app-details-shell>
} @else if (isLoading()) {
  <p class="p-6 text-sm text-muted-foreground">
    {{ 'settings.organizations.details.loading' | transloco }}
  </p>
}
